
import * as models from "app/models/requireme";
import * as resources from "app/resources/index";
import * as React from "react";
import * as kea from "kea-react";

import { SelectorSimpleFactory, SelectorFiltradoFactory } from "app/features/selectores/logic";

import { FilterMatrix, onUndefinedAll, ListFilter, invertFilter, joinFilter, applyFilterMatrix } from "filtermatrix";
import { mapObject, first, single, omitUndefined } from "keautils";

interface ItemTypes {
    estado: models.Estado;
    ciudad: models.CiudadDTO;
    municipio: models.MunicipioDTO;
}

export type Listas = {[K in keyof ItemTypes]: ItemTypes[K][]};
export type Ids = {[K in keyof ItemTypes]?: number | null};;
type Entities = {[K in keyof ItemTypes]?: ItemTypes[K]};;

function getFilterMatrix(data: Listas) {
    const idem = x => x;

    const estadosPorMunicipio: ListFilter<models.Estado, models.MunicipioDTO> = onUndefinedAll((items, value) => items.filter(x => x.IdRegistro == value.IdEstado));
    const municipiosPorCiudad: ListFilter<models.MunicipioDTO, models.CiudadDTO> = onUndefinedAll((items, value) => items.filter(x => x.IdRegistro == value.IdMunicipio));
    const estadosPorCiudad: ListFilter<models.Estado, models.CiudadDTO> = onUndefinedAll((items, value) => items.filter(x => x.IdRegistro == value.IdEstado));

    const municipiosPorEstado = invertFilter(estadosPorMunicipio);
    const ciudadesPorMunicipio = invertFilter(municipiosPorCiudad);
    const ciudadesPorEstado = invertFilter(estadosPorCiudad);

    const matrix: FilterMatrix<ItemTypes> = {
        estado: {
            estado: idem,
            municipio: estadosPorMunicipio,
            ciudad: estadosPorCiudad
        },
        municipio: {
            estado: municipiosPorEstado,
            municipio: idem,
            ciudad: municipiosPorCiudad
        },
        ciudad: {
            estado: ciudadesPorEstado,
            municipio: ciudadesPorMunicipio,
            ciudad: idem
        }
    };
    return matrix;
}

function obtenerEntidadesDeValores(ids: Ids, data: Listas): Entities {
    const ret = mapObject(ids, (value, key) => first<ItemTypes[keyof Listas]>(data[key], item => item.IdRegistro == value));
    return ret as Entities;
}

/**Filtra los selectores de estado ciudad y municipio de manera codependiente */
export function filtrarListas(ids: Ids, data: Listas): Listas {
    const entidades = obtenerEntidadesDeValores(ids, data);
    const matrix = getFilterMatrix(data);
    const filtrado = applyFilterMatrix(matrix)(data)(entidades);

    return filtrado;
}

/**Sugiere los valores de las listas filtradas que tengan sólo un elemento */
export function sugerirValores(filtrado: Listas): Ids {
    const ret = mapObject(filtrado, valor => single((valor as any[]).map(x => x.IdRegistro)))
    return omitUndefined(ret);
}


// WEBPACK FOOTER //
// ./app/features/selectores/items/municipio/logic.tsx